import { isThemeToken } from '@nettbureau/theme';

/**
 * Parses a color and color tone to its CSS value based on the theme.
 *
 * @param theme - The theme object.
 * @param color - The color to resolve a value for.
 * @param tone - The level of tone to apply to the color.
 */ function parseColor(theme, color, tone) {
    const resolvedColor = resolveColorAlias(theme, color);
    return theme.colors[resolvedColor][tone];
}
/**
 * Resolves a color alias to an actual color token.
 *
 * @template TColor - Type of color which should extend possible color aliases.
 * @param theme - The theme object.
 * @param color - The color or alias to resolve a value for.
 */ function resolveColorAlias(theme, color) {
    if (isThemeToken(color, theme.aliases.colors)) {
        return theme.aliases.colors[color];
    }
    return color;
}

export { parseColor, resolveColorAlias };
//# sourceMappingURL=color.js.map
